import infoBarStrings from 'owa-strings/owa-common-strings';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import trySaveMessage from '../actions/trySaveMessage';
var upgradeToPremiumUrl = '';
var accountRecoveryFlowUrl = '';
var hipControlUrl = '/owa/owahipcontrol.aspx?compose=1';
export function preHandleErrorResponse(response, viewState) {
    if (response) {
        if (response.WasclUpgradeToPremiumUrl) {
            upgradeToPremiumUrl = response.WasclUpgradeToPremiumUrl;
        }
        if (response.AccountRecoveryFlowUrl) {
            accountRecoveryFlowUrl = response.AccountRecoveryFlowUrl;
        }
        var responseMessage = response.ResponseMessages && response.ResponseMessages.Items
            ? response.ResponseMessages.Items[0]
            : null;
        if (responseMessage &&
            (responseMessage.ResponseCode == 'ErrorExceededMessageLimit' ||
                responseMessage.ResponseCode == 'ErrorExceededHourlyMessageLimit' ||
                responseMessage.ResponseCode == 'ErrorExceededMessageLimitShowTierUpgrade')) {
            trySaveMessage(viewState, true /*isAutoSave*/);
        }
    }
}
export function getUpgradeToPremiumButton(viewState) {
    return {
        text: infoBarStrings.errorMessageUpgradeToPremium,
        action: function () {
            removeInfoBarMessage(viewState, [
                'errorMessageExceededMessageLimit',
                'errorMessageExceededMaxRecipientLimit',
            ]);
            window.open(upgradeToPremiumUrl);
        },
    };
}
export function getHipVerifyButton(viewState) {
    return {
        text: infoBarStrings.errorMessageVerify,
        action: function () {
            removeInfoBarMessage(viewState, [
                'errorMessageMessageSubmissionBlocked',
                'errorMessageExceededMaxRecipientLimitShowTierUpgrade',
                'errorMessageExceededMessageLimitShowTierUpgrade',
            ]);
            window.open(hipControlUrl);
        },
    };
}
export function getAccountRecoveryFlowButton(viewState) {
    return {
        text: infoBarStrings.errorMessageVerify,
        action: function () {
            removeInfoBarMessage(viewState, [
                'errorMessageAccountSuspend',
                'errorMessageAccountSuspendShowTierUpgrade',
            ]);
            window.open(accountRecoveryFlowUrl);
        },
    };
}
//# sourceMappingURL=wasclUtils.js.map